import {
  Component,
  OnInit,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { StakeholderService } from '@/app/services/stakeholder.service';
import { CommonModule } from '@angular/common';
import { environment } from '@/app/environments/environment';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { VIEW_MODE } from '@/app/interfaces/view-mode.enum';
import { GalleryComponent } from '@/app/components/shared/gallery/gallery.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { InputFieldComponent } from '@/app/components/global/input-field/input-field.component';
import { NgToastService } from 'ng-angular-popup';
import { KeyDeliverableComponent } from '@/app/components/global/key-deliverable/key-deliverable.component';
import { StakeholderComponent } from '@/app/components/global/stakeholder/stakeholder.component';
import { ViewModeProjectTypeComponent } from '@/app/components/global/view-mode-project-type/view-mode-project-type.component';
import { Stage1ViewGradeComponent } from '@/app/components/global/stage1-view-grade/stage1-view-grade.component';
import { DateComponent } from '@/app/components/global/date/date.component';
import { CountryComponent } from '../../../../global/inputs/country/country.component';
import { ApprovalStatusViewComponent } from '@/app/components/global/approval-status-view/approval-status-view.component';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { MilestoneComponent } from '@/app/components/global/milestone/milestone.component';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { PROJECT_STAGE } from '@/app/enums/project_stages.enum';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { ReloadPlanDataService } from '@/app/services/shared/reload-plan-data.service';

@Component({
  selector: 'app-stage1viewmode',
  standalone: true,
  imports: [
    CommonModule,
    GalleryComponent,
    MatDialogModule,
    MatButtonModule,
    InputFieldComponent,
    KeyDeliverableComponent,
    StakeholderComponent,
    ViewModeProjectTypeComponent,
    Stage1ViewGradeComponent,
    DateComponent,
    CountryComponent,
    ApprovalStatusViewComponent,
    MilestoneComponent,
    RichTextEditorComponent,
  ],
  templateUrl: './stage1viewmode.component.html',
  styleUrl: './stage1viewmode.component.css',
})
export class Stage1viewmodeComponent implements OnInit {
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  @Output() changeProjectBriefViewMode: EventEmitter<VIEW_MODE> =
    new EventEmitter<VIEW_MODE>();
  @Output() projectBriefEmitter: EventEmitter<string> =
    new EventEmitter<string>();
  selectedImage: any = null;
  selectedImageGroup = 0;
  currentImageIndex = 0;
  selectedMainImage: any = null;
  projectId: any;
  latitude_value: any;
  longitude_value: any;
  mapLink!: SafeResourceUrl;
  uploadedFiles: any[] = [];
  DocumentFiles: any[] = [];
  stakeholders: any[] = [];
  editField: string;
  updatedCountryId: any;
  selectedMileStoneId: any;
  isImagesEdit = false;
  isDocumentsEdit = false;
  @Output() changeEdit: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private router: Router,
    private projectsService: ProjectsService,
    private stakeholderService: StakeholderService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private toast: NgToastService,
    private GetProjectIdService: GetProjectIdService,
    private route: ActivatedRoute,
    private reloadPlanDataService: ReloadPlanDataService
  ) {}
  projectData: any;
  base_path = environment.storageUrl;
  google_api_key = environment.apiKey;
  revisionId: number;
  PROJECT_STAGE = PROJECT_STAGE;

  gmpCheck = new FormControl(0);

  private subscription: Subscription = new Subscription();
  projectBrief: string;
  projectSiteCondition: string;
  resetRichTextEditor = false;
  ngOnInit(): void {
    this.getStakeholder();
    this.getProject();
    if (this.projectData?.parent_document?.length) {
      this.selectedMainImage = this.projectData.parent_document[0].files[0];
    }
    this.subscription = this.GetProjectIdService.projectId$.subscribe(() => {
      this.getProject();
    });
    this.reloadPlanDataService.reloadPlanData$.subscribe((reload) => {
      if (reload) {
        this.getProject();
      }
    });
  }

  updateCountry(country: any) {
    this.updatedCountryId = country.id;
  }

  handleClose() {
    this.router.navigate([`/projects`]);
  }

  getProject(): void {
    this.projectsService.getProjectDetails().subscribe({
      next: (response: any) => {
        this.projectData = response;
        this.projectId = this.projectData?.id
          ? this.projectData?.id
          : this.GetProjectIdService.getProjectId();
        this.latitude_value = this.projectData.latitude;
        this.longitude_value = this.projectData.longitude;

        const url = `https://www.google.com/maps/embed/v1/place?key=${this.google_api_key}&q=${this?.latitude_value},${this?.longitude_value}&zoom=16`;
        this.mapLink = this.sanitizer?.bypassSecurityTrustResourceUrl(url);

        const images = response?.parent_document.filter(
          (image: any) => image.type === 'site_conditions'
        );

        const documents = response?.parent_document.filter(
          (document: any) => document.type === 'location'
        );

        this.uploadedFiles = images;
        this.DocumentFiles = documents;

        this.projectBriefEmitter.emit(response);

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching Details:', error);
      },
    });
  }
  getStakeholder() {
    this.stakeholderService.getStakeholders().subscribe({
      next: (response: any) => {
        this.stakeholders = response;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching stakeholder:', error);
      },
    });
  }

  openDialog(): void {
    this.dialog.open(this.dialogTemplate);
  }
  navigateToEditAll(): void {
    this.dialog.open(this.dialogTemplate);
    this.router.navigate(['/add-stage-1']);
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  truncateDescription(description: string): string {
    const maxLength = 30;

    if (description?.length > maxLength) {
      return description?.slice(0, maxLength) + '';
    }
    return description;
  }
  onMilestoneToggle(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.projectData.milestones_enabled = checked ? 1 : 0;
  }
  navigateTo() {
    localStorage.setItem('isEdit', String(true));
    this.changeProjectBriefViewMode.emit(VIEW_MODE.EDIT);
  }
  openPreview(groupIndex: number) {
    this.currentImageIndex = groupIndex;
    this.selectedImage =
      this.projectData.parent_document[groupIndex].files[groupIndex];
  }

  closePreview() {
    this.selectedImage = null;
  }

  prevImage() {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.selectedImage =
        this.projectData.parent_document[this.selectedImageGroup].files[
          this.currentImageIndex
        ];
    }
  }

  nextImage() {
    if (
      this.currentImageIndex <
      this.projectData.parent_document[this.selectedImageGroup].files.length - 1
    ) {
      this.currentImageIndex++;
      this.selectedImage =
        this.projectData.parent_document[this.selectedImageGroup].files[
          this.currentImageIndex
        ];
    }
  }

  isImageFile(file: any): boolean {
    return (
      file.file_path.endsWith('.jpg') ||
      file.file_path.endsWith('.jpeg') ||
      file.file_path.endsWith('.png') ||
      file.file_path.endsWith('.svg')
    );
  }
  setMainImage(groupIndex: number, imageIndex: number) {
    this.selectedMainImage =
      this.projectData.parent_document[groupIndex].files[imageIndex];
  }

  numberToWords(num: any) {
    if (num === 0) return 'zero';

    const belowTwenty = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen',
    ];
    const tens = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety',
    ];
    const thousands = ['', 'thousand', 'million', 'billion', 'trillion'];

    function helper(n) {
      if (n === 0) return '';
      else if (n < 20) return belowTwenty[n] + ' ';
      else if (n < 100) return tens[Math.floor(n / 10)] + ' ' + helper(n % 10);
      else
        return belowTwenty[Math.floor(n / 100)] + ' hundred ' + helper(n % 100);
    }

    let word = '';
    let index = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[index] + ' ' + word;
      }
      num = Math.floor(num / 1000);
      index++;
    }

    return word.trim();
  }

  openPdf(imageSrc: any): void {
    window.open(imageSrc, '_blank');
  }

  handleImagesSelect(currentField: string) {
    this.editField = currentField;
    this.isImagesEdit = true;
    this.cdr.detectChanges();
  }
  handleDocumentsSelect(currentField: string) {
    this.editField = currentField;
    this.isDocumentsEdit = true;
    this.cdr.detectChanges();
  }

  handleSelectField(currentField: string) {
    this.editField = currentField;

    this.cdr.detectChanges();
  }
  handleSelectMileStoneField(currentField: string, Id: number) {
    this.editField = currentField;
    this.selectedMileStoneId = Id;
    this.cdr.detectChanges();
  }

  onCLose() {
    this.editField = '';
    this.selectedMileStoneId = '';
    this.isImagesEdit = false;
    this.isDocumentsEdit = false;
  }
  async onSave(value: any) {
    const dataToSubmit = new FormData();
    if (this.editField === 'projectTitle') {
      dataToSubmit.append('name', value);
      this.projectData.name = value;
    } else if (this.editField === 'brief') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('description', value);
      this.projectData.description = value;
    } else if (this.editField === 'siteCondition') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('site_conditions', value);
      this.projectData.site_conditions = value;
    } else if (this.editField === 'keyDeliverable') {
      dataToSubmit.append('name', this.projectData?.name);
      value.forEach((keyDeliverable: any) => {
        if (keyDeliverable.name) {
          dataToSubmit.append('key_deliverables[]', keyDeliverable.name);
        }
      });
      this.projectData.goals = value;
    } else if (this.editField === 'stakeholder') {
      dataToSubmit.append('name', this.projectData?.name);
      value.forEach((stakeholder: any) => {
        if (stakeholder.stake_holder) {
          dataToSubmit.append('stake_holders[]', stakeholder.stake_holder);
        }
      });
      this.projectData.stake_holders = value;
    } else if (this.editField === 'projectType') {
      dataToSubmit.append('name', this.projectData?.name);

      if (value.updatedCustomProjectType) {
        let parantId = null;
        if (value.updatedCustomParantId) {
          parantId = value.updatedCustomParantId;
        } else {
          parantId = null;
        }
        const customData = {
          parent_id: parantId,
          name: value.updatedCustomProjectType,
        };
        try {
          const customTypeResponse = await this.createCustomProjectType(
            customData
          );
          if (customTypeResponse.id) {
            dataToSubmit.append('project_type_id', customTypeResponse.id);
          } else {
            dataToSubmit.append(
              'project_type_id',
              customTypeResponse.parent_id
            );
          }
        } catch (error) {
          console.error('Error creating custom project type:', error);
        }
      } else {
        if (value?.updatedProjectSubTypeId || value?.updatedProjectTypeId) {
          dataToSubmit.append(
            'project_type_id',
            value?.updatedProjectSubTypeId || value?.updatedProjectTypeId
          );
        }
      }
    } else if (this.editField === 'grade') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('grade_id', value);
    } else if (this.editField === 'startDate') {
      dataToSubmit.append('name', this.projectData?.name);      
      dataToSubmit.append('start_date', this.formatDateString(value));
    } else if (this.editField === 'endDate') {
      dataToSubmit.append('name', this.projectData?.name);      
      dataToSubmit.append('end_date', this.formatDateString(value));
    } else if (this.editField === 'latitude') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('latitude', value);
    } else if (this.editField === 'longitude') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('longitude', value);
    } else if (this.editField === 'street') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('street', value);
    } else if (this.editField === 'zipCode') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('zip', value);
    } else if (this.editField === 'city') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('city', value);
    } else if (this.editField === 'country') {
      dataToSubmit.append('name', this.projectData?.name);
      dataToSubmit.append('country_id', value);
    } else if (this.editField === 'totalAllocated') {
      dataToSubmit.append('fieldName', 'budget_amount');
      dataToSubmit.append('budget_amount', value);
    } else if (this.editField === 'gmp') {
      dataToSubmit.append('fieldName', 'budget_gmp');
      dataToSubmit.append('budget_gmp', value);
    } else if (this.editField === 'risk&contingency') {
      dataToSubmit.append('fieldName', 'budget_risk');
      dataToSubmit.append('risk_and_contengency_amount', value);
    } else if (this.editField === 'milestone') {
      dataToSubmit.append('project_id', this.projectData?.id);
      dataToSubmit.append('id', this.selectedMileStoneId);
      dataToSubmit.append('name', value.name);
      dataToSubmit.append('start_date', this.formatDateString(value.start_date));
      dataToSubmit.append('end_date', this.formatDateString(value.end_date));

      this.updateMileStoneOfProject(dataToSubmit, this.selectedMileStoneId);
      this.selectedMileStoneId = '';
    } else if (this.editField === 'siteImages') {
      dataToSubmit.append('name', this.projectData?.name);
      value?.deleted_attachments.forEach((file: any) => {
        if (file) {
          dataToSubmit.append('deleted_attachments[]', file);
        }
      });
      const site_condition_document: any = value?.uploadedFiles.filter(
        (file: any) => !file.id
      );
      site_condition_document.forEach((uploadedFile: any) => {
        if (uploadedFile.file) {
          dataToSubmit.append('site_condition_documents[]', uploadedFile.file);
        }
      });
      this.isImagesEdit = false;
    } else if (this.editField === 'documents') {
      dataToSubmit.append('name', this.projectData?.name);
      value?.deleted_attachments.forEach((file: any) => {
        if (file) {
          dataToSubmit.append('deleted_attachments[]', file);
        }
      });
      const site_condition_document: any = value?.uploadedFiles.filter(
        (file: any) => !file.id
      );
      site_condition_document.forEach((uploadedFile: any) => {
        if (uploadedFile.file) {
          dataToSubmit.append('location_attachments[]', uploadedFile.file);
        }
      });
      this.isDocumentsEdit = false;
    }

    if (
      this.editField !== 'milestone' &&
      this.editField !== 'totalAllocated' &&
      this.editField !== 'gmp' &&
      this.editField !== 'risk&contingency'
    ) {
      this.addNewVersionOfProject(dataToSubmit);
    } else if (
      this.editField === 'totalAllocated' ||
      this.editField === 'gmp' ||
      this.editField === 'risk&contingency'
    ) {
      this.updateSingleFieldOfProject(dataToSubmit);
    }

    this.editField = '';
  }

  addNewVersionOfProject(dataToSubmit: any) {
    this.projectsService.updateProjectInfo(dataToSubmit).subscribe({
      next: () => {
        this.toast.success(
          'New version of project added successfully',
          'SUCCESS',
          4000
        );
        this.getProject();
      },
      error: (error) => {
        this.toast.danger(error.error.message, 'DANGER', 4000);
        console.error('Unable to add new version of the project:', error);
      },
    });
  }

  updateSingleFieldOfProject(dataToSubmit: any) {
    this.projectsService
      .editSingleFieldofProject(dataToSubmit, this.projectId)
      .subscribe({
        next: () => {
          this.toast.success(
            'New version of project added successfully',
            'SUCCESS',
            4000
          );
          this.getProject();
        },
        error: (error) => {
          this.toast.danger(error.error.message, 'DANGER', 4000);
          console.error('Unable to add new version of the project:', error);
        },
      });
  }

  updateMileStoneOfProject(dataToSubmit: any, milestoneId: any) {
    this.projectsService
      .updateMilestoneProject(dataToSubmit, milestoneId)
      .subscribe({
        next: () => {
          this.toast.success(
            'New version of project added successfully',
            'SUCCESS',
            4000
          );
          this.getProject();
        },
        error: (error) => {
          this.toast.danger(error.error.message, 'DANGER', 4000);
          console.error('Unable to add new version of the project:', error);
        },
      });
  }
  createCustomProjectType(customData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.projectsService.createCustomProjectTypes(customData).subscribe({
        next: (response: any) => {
          resolve(response.data);
        },
        error: (error) => {
          console.error('Unable to add new version of the project:', error);
          reject(error);
        },
      });
    });
  }

  onGmpCheckChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.gmpCheck.setValue(isChecked ? 1 : 0);
  }

  save() {
    this.onSave(this.gmpCheck.value);
  }

  cancel() {
    this.onCLose();
  }
  addProjectBrief(content: string) {
    this.projectBrief = content;
  }
  addProjectSiteCondition(content: string) {
    this.projectSiteCondition = content;
  }

  private formatDateString(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
